import { useState } from "react";
import { revenueChartData } from "@/mocks/dashboard";

export default function RevenueChart() {
  const [activeMetric, setActiveMetric] = useState<"revenue" | "volume">("revenue");

  const data = revenueChartData;
  const maxRevenue = Math.max(...data.map(d => d.revenue));
  const maxVolume = Math.max(...data.map(d => d.volume));
  const maxVal = activeMetric === "revenue" ? maxRevenue : maxVolume;

  const formatValue = (val: number) => {
    if (activeMetric === "revenue") {
      return `${(val / 10000).toFixed(0)}万`;
    }
    return `${(val / 10000).toFixed(0)}万m³`;
  };

  return (
    <div className="bg-white rounded-xl p-5 border border-gray-100">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-sm font-semibold text-gray-800">营收趋势</h3>
          <p className="text-xs text-gray-400 mt-0.5">2025年全年数据</p>
        </div>
        <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
          <button
            onClick={() => setActiveMetric("revenue")}
            className={`px-3 py-1 text-xs rounded-md transition-colors cursor-pointer whitespace-nowrap ${
              activeMetric === "revenue" ? "bg-white text-gray-800 font-medium shadow-sm" : "text-gray-500"
            }`}
          >
            营收金额
          </button>
          <button
            onClick={() => setActiveMetric("volume")}
            className={`px-3 py-1 text-xs rounded-md transition-colors cursor-pointer whitespace-nowrap ${
              activeMetric === "volume" ? "bg-white text-gray-800 font-medium shadow-sm" : "text-gray-500"
            }`}
          >
            用气量
          </button>
        </div>
      </div>

      <div className="flex items-end gap-2 h-40">
        {data.map((item, idx) => {
          const val = activeMetric === "revenue" ? item.revenue : item.volume;
          const height = (val / maxVal) * 100;
          return (
            <div key={idx} className="flex-1 flex flex-col items-center gap-1 group">
              <div className="relative w-full flex items-end justify-center" style={{ height: "120px" }}>
                <div
                  className="w-full bg-[#E8531A]/15 rounded-t-md group-hover:bg-[#E8531A]/25 transition-colors relative"
                  style={{ height: `${height}%` }}
                >
                  <div
                    className="absolute bottom-0 left-0 right-0 bg-[#E8531A] rounded-t-md"
                    style={{ height: "3px" }}
                  ></div>
                  <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-1.5 py-0.5 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                    {formatValue(val)}
                  </div>
                </div>
              </div>
              <span className="text-xs text-gray-400">{item.month}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
